import Vue from 'vue';
import wysiwyg from 'vue-wysiwyg';
import 'vue-wysiwyg/dist/vueWysiwyg.css';

Vue.use(wysiwyg);
